import { Folder as FolderIcon } from 'lucide-react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Folder } from '../collections.types'

type CollectionsFilterSelectProps = {
  folders: Folder[]
  selectedFolderId: string | null
  onSelect: (folderId: string | null) => void
}

// Narrow-screen stand-in for the Collections sidebar, styled to match the Categories filter.
export const CollectionsFilterSelect = ({
  folders,
  selectedFolderId,
  onSelect,
}: CollectionsFilterSelectProps) => {
  const selectedFolder = folders.find((f) => f.id === selectedFolderId) ?? null

  return (
    <Select
      value={selectedFolderId ?? 'all'}
      onValueChange={(value) => onSelect(value === 'all' ? null : value)}
    >
      <SelectTrigger className="h-10 w-[200px] rounded-lg bg-background text-sm shadow-sm border border-border">
        <SelectValue>
          <span className="inline-flex items-center gap-2 truncate">
            <FolderIcon className="h-4 w-4 shrink-0 text-muted-foreground" />
            {selectedFolder ? selectedFolder.name : 'All documents'}
          </span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All documents</SelectItem>
        {folders.map((folder) => (
          <SelectItem key={folder.id} value={folder.id}>
            {folder.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
